import React from 'react';
import About from './components/About';
import Contact from './components/Contact';
import Navbar from './components/Navbar';
import Welcome from './components/Welcome';

const App = () => {
  return (
    <div
      className={`antialiased dark:bg-blue-950 dark:text-white min-h-screen border-8 border-indigo-700`}
    >
      <Navbar />
      <Welcome />
      <About />
      <Contact />
    </div>
  );
};

export default App;
